<template>
  <div class="p-6 border-t cursor-pointer dark:border-dark-divider-border" :class="[{ 'h-32': !expanded }]" @click="expanded = !expanded">
    <div class="flex items-start gap-x-6">
      <div class="flex items-center gap-x-2">
        <Avatar
          :first-name="email.meta_data.from[0].name ? email.meta_data.from[0].name.split(' ')[0] : email.meta_data.from[0].email"
          :last-name="email.meta_data.from[0].name.split(' ')[1]" />
        <div :class="[`${email.meta_data.unread ? 'font-extrabold' : 'font-normal'}`]" class="dark:text-white whitespace-nowrap">
          {{ email.meta_data.from[0].name ? email.meta_data.from[0].name : email.meta_data.from[0].email }}
        </div>
      </div>

      <div class="ml-auto text-sm whitespace-nowrap" :class="[`${email.meta_data.unread ? 'font-extrabold' : 'font-normal'}`]">
        {{ $moment(email.interaction_date).format("DD MMM  YYYY") }} at {{ $moment(email.interaction_date).format("hh:mm A") }}
      </div>
    </div>

    <div class="mt-2 ml-10">
      <div :class="['overflow-hidden', { 'max-h-12': !expanded }]" v-html="clean_html" />
    </div>
  </div>
</template>

<script>
import Avatar from "@/components/shared/Avatar.vue"

export default {
  components: { Avatar },
  props: {
    email: {
      type: Object,
      required: true
    },
    initiallyExpanded: {
      type: Boolean,
      required: false
    }
  },
  emits: [],
  data() {
    return {
      expanded: false,
      clean_html: null
    }
  },
  watch: {},

  created() {
    const htmlObject = document.createElement("div")
    htmlObject.innerHTML = this.email.description
    if (htmlObject.getElementsByClassName("gmail_quote")) {
      htmlObject.getElementsByClassName("gmail_quote")[0]?.remove()
    }
    this.clean_html = htmlObject.outerHTML
    if (this.initiallyExpanded) {
      this.expanded = true
    }
  },

  methods: {}
}
</script>
